export const FETCH_PRODUCT_SUMMARY = 'FETCH_PRODUCT_SUMMARY';
export const FETCH_OVERVIEW_PRODUCT_SUMMARY = 'FETCH_OVERVIEW_PRODUCT_SUMMARY';
